import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';
import { Button, List, Title } from '@zenterprise-inc/ui';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

export const RefundResultManual = () => {
  const { sendClickEvent } = useUserEventLogger();
  const { openChannelTalk } = useChannelTalk();
  const items = [
    {
      iconFileName: 'fill-account-right-rg.svg',
      title: '입력하셨던 환급 계좌로 입금돼요',
      subText: "국세청이나 관할서에서 보통 ‘OO관할세무서‘, ‘국고환급', ‘센타입금' 등의 입금자명으로 입금해요."
    },
    {
      iconFileName: 'fill-collect-coin-yl-rg.svg',
      title: '연도별로 분할되어 입금돼요',
      subText: '각각 다른 날짜에 입금될 수 있어요.'
    },
    {
      iconFileName: 'fill-5-clock-rg.svg',
      title: '결정일로부터 평균 3일 정도 소요돼요',
      subText: '늦어지는 경우 최대 14일까지도 소요될 수 있어요.'
    },
    {
      iconFileName: 'fill-megaphone-or-rg.svg',
      title: '입금된 금액이 다를 수 있어요',
      subText: '연도별로 이자가 더해지면 더 많이 입금될 수 있어요. 반대로 체납액이나 예정 납부액이 있다면 자동 충당되어 더 적게 입금될 수 있어요.'
    },
    {
      iconFileName: 'icg_plus_md.svg',
      title: '종합소득세·양도소득세는 지방세 환급돼요',
      subText: '국세청으로부터 환급금이 입금되고 1~2개월 후에 관할 지방청에서 지방세 환급금을 입금해요.'
    }
  ];
  return (
    <div className={'page-padding flex flex-col justify-between'}>
      <div className={'pb-6'}>
        <Title.Headline title={'비즈넵 환급을 신청하면\n환급금은 이렇게 입금돼요'} size="large" className={'mb-3'} />
        {items.map((item, index) => (
          <List.Basic
            key={index}
            left={
              <img
                width={40}
                height={40}
                src={`/images/illus-icons/${item.iconFileName}`}
                alt={`${item.iconFileName.replace(/.svg|fill-|-yl|-or|-rg/g, '').replace(/-/g, ' ')} icon`}
              />
            }
            title={{ text: item.title, titleStyle: 'font-bold' }}
            subText={{
              text: item.subText
            }}
          />
        ))}
      </div>
      <div className={'full-width text-14 w-full self-center justify-self-end border-t py-12 pl-7 pr-7 text-center text-gray-700'}>
        <span className={'mr-2.5'}>궁금하신 점이 있으시면 문의해주세요.</span>
        <Button.Box
          state={'secondary'}
          size={'small'}
          onClick={() => {
            sendClickEvent('deposit-guide_body_cx');
            openChannelTalk(SUPPORT_BOT_LINK.home);
          }}
        >
          문의하기
        </Button.Box>
      </div>
    </div>
  );
};
